import { USERS_API_BASE } from './apiConfig';
import { apiRequest } from './httpClient';

export const fetchUserList = async () => apiRequest(USERS_API_BASE);

export const registerUser = async ({ username, password, name, role }) => {
  return apiRequest(USERS_API_BASE, {
    method: 'POST',
    body: JSON.stringify({ username, password, name, role }),
  });
};

export const updateUserRole = async (id, role) => {
  return apiRequest(`${USERS_API_BASE}/${id}/role`, {
    method: 'PATCH',
    body: JSON.stringify({ role }),
  });
};

export const deleteUser = async (id, confirmUsername) => {
  await apiRequest(`${USERS_API_BASE}/${id}`, {
    method: 'DELETE',
    body: JSON.stringify({ confirmUsername }),
  });
};

export const fetchMyProfile = async () => apiRequest(`${USERS_API_BASE}/me`);

export const updateMyName = async (name) => {
  return apiRequest(`${USERS_API_BASE}/me`, {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });
};

export const changeMyPassword = async ({ currentPassword, newPassword }) => {
  await apiRequest(`${USERS_API_BASE}/me/password`, {
    method: 'PATCH',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
};
